import { render } from "./AttackVue.vue?vue&type=template&id=3cb9ae29"
import script from "./AttackVue.vue?vue&type=script&lang=js"
export * from "./AttackVue.vue?vue&type=script&lang=js"

import "./AttackVue.vue?vue&type=style&index=0&id=3cb9ae29&lang=css"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__